var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isReady)?_c('Loader'):_c('div',{staticClass:"explorer"},[_c('img',{attrs:{"src":require("../assets/globus.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }